import { render } from "./copySchedule.vue?vue&type=template&id=88639c0c&scoped=true"
import script from "./copySchedule.vue?vue&type=script&lang=js"
export * from "./copySchedule.vue?vue&type=script&lang=js"

import "./copySchedule.vue?vue&type=style&index=0&id=88639c0c&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88639c0c"]])

export default __exports__